<template>
    <div>
        <!-- Parents -->
        <h1>Parents</h1>
        <p><u>sub-head-{parents}</u></p>
        <br />
        <v-row align="center">
            <v-col cols="12">
                <sub-head-primary itemTitle="가이드" tabActive="예시페이지" bg="/images/test.jpg">
                    <template #title>가이드</template>
                </sub-head-primary>
            </v-col>
            <v-col cols="12">
                <sub-head-secondary itemTitle="가이드" tabActive="예시페이지" bg="/images/test.jpg">
                    <template #title>가이드</template>
                </sub-head-secondary>
            </v-col>
        </v-row>
        <!-- // Parents -->

        <v-divider class="my-30px" />

        <!-- With -->
        <h1>With</h1>
        <p><u>sub-head--with-header</u></p>
        <p><u>sub-head--with-tabs</u></p>
        <p>위 클래스 추가 시 header 또는 tab이 이미지영역 위로 올라옵니다.</p>
        <!-- // Default -->
    </div>
</template>

<script>
import SubHeadPrimary from "@/sets/parents/pages/sub-head-primary.vue";
import SubHeadSecondary from "@/sets/parents/pages/sub-head-secondary.vue";

export default {
    props: {},
    components: {
        SubHeadPrimary,
        SubHeadSecondary,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
// 가이드 작업을 위해 넣어 놓은 스타일입니다.
.sub-head--with-header {
    margin-top: 0;
}
</style>
